export default __webpack_public_path__ + "_/shared_modules/sprites/dist/sprite-k12-banner-educator-72d6920491ec67ad966f603d1f7c6001.png";